export const workflowCreateConstants = {
  CREATE_REQUEST: "WORKFLOW_CREATE_REQUEST",
  CREATE_SUCCESS: "WORKFLOW_CREATE_SUCCESS",
  CREATE_FAILURE: "WORKFLOW_CREATE_FAILURE"
};
